export default __webpack_public_path__ + "static/media/IMG_2197.c2b7ea51.jpg";